// tslint:disable: no-bitwise
export enum ItemLoyaltyState {
  None = 0,
  ComingSoon = 1 << 0,
  TestItem = 1 << 1,
  AgeRestricted = 1 << 2,
  NotInPopulation = 1 << 3,
  OutOfStock = 1 << 4,
  ItemLimitReached = 1 << 5,
  ItemClosed = 1 << 7,
  ItemNotStarted = 1 << 8,
}
